import React, { useState, useEffect } from "react";
import { InputLabel,  FormControl, Select,MenuItem, Typography, Button, CircularProgress, Box, Modal } from "@mui/material";
import axios from "axios";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../../admin/UserContext";
import { IoClose } from "react-icons/io5";

const coloresDisponibles = [
  "#1A425B",
  "#FFFFFF",
  "#00A69E",
  "#6A3090",
  "#FFA457",
];


export const EditarServicioSelecion = ({ onclose, slider, fetchSliders }) => {
       const { Token } = useUserAdmin();
  const backendURL = process.env.REACT_APP_BACKEND_URL;

  const [formData, setFormData] = useState({
     icono: null,
    imagen_icono: null,
    imagen_icono2: null,
    titulo: "",
    titulo1: "",
    descripcion: "",
    descripcion1: "",
    color: "",
  });

  const [loading, setLoading] = useState(false);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");


  // Obtener datos iniciales del slider
  useEffect(() => {
    const fetchSlider = async () => {
      try {
        const response = await axios.get(`${backendURL}/api/servicio/home/especifico/${slider}`, {
          headers: { Authorization: `Bearer ${Token}` },
        });
        const data = response.data.data;
        setFormData({
          icono: data.icono || null,
          imagen_icono: data.imagen_icono || null,
          imagen_icono1: data.imagen_icono1 || null,
          titulo: data.titulo || "",
          titulo2: data.titulo2 || "",
          descripcion: data.descripcion || "",
          descripcion1: data.descripcion1 || "",
          color: data.color || "",
        });
      } catch (error) {
        console.error("Error al obtener slider:", error);
      }
    };
    fetchSlider();
  }, [slider, backendURL, Token]);

  // Vista previa para la imagen
  const renderPreview = (file) => {
    if (!file) return null;
    const url = typeof file === "string" ? `${backendURL}/${file}` : URL.createObjectURL(file);
    return <img src={url} alt="preview" style={{ width: "100%", marginBottom: 10 }} />;
  };

  // Manejo de cambio en inputs texto y color
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Manejo de archivo para icono
  const handleFileChange = (e, name) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, [name]: file }));
  };


const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setEnviandoAlert(true);

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
        if (value) data.append(key, value);
    });

    try {
        await axios.post(`${backendURL}/api/editar/servicio/home/${slider}`, data, {
            headers: {
                Authorization: `Bearer ${Token}`,
                'Content-Type': 'multipart/form-data',
            },
        });

        setAlertMessage("Actualizado correctamente.");
        setSuccessAlertOpen(true);
        
    } catch (error) {
        setAlertMessage("Error al actualizar.");
        setErrorAlertOpen(true);
        console.error("Error al actualizar:", error);
    } finally {
        setLoading(false);
        setEnviandoAlert(false);
        await fetchSliders()
        setTimeout(() => {
        setSuccessAlertOpen(false);
         setEnviandoAlert(false)
        setErrorAlertOpen(false);
        onclose();
       
      }, 3000);
    }
};
    return (
        <Box>
            <h3>Editar Producto home {slider}</h3>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de fondo</InputLabel>
                            {renderPreview(formData.icono)}

                    <input type="file" accept="image/*" onChange={handleFileChange} style={inputStyle} />
                </div>
                 <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen icono</InputLabel>
                            {renderPreview(formData.imagen_icono)}

                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "imagen_icono")} style={inputStyle} />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen icono dos</InputLabel>
                            {renderPreview(formData.imagen_icono2)}

                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "imagen_icono2")} style={inputStyle} />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo</InputLabel> 
                    <input
                        name="titulo"
                        label="Título"
                        value={formData.titulo}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857",  color:'#585857', background:'#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                        />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo dos</InputLabel> 
                    <input
                        name="titulo1"
                        label="Título"
                        value={formData.titulo1}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857",  color:'#585857', background:'#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                        />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Descripción</InputLabel> 
                    <input
                        name="descripcion"
                        value={formData.descripcion}
                        onChange={handleInputChange}
                        label="Título"

                        style={{ border: "2px solid #585857",  color:'#585857', background:'#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                        />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Descripción dos</InputLabel> 
                    <input
                        name="descripcion1"
                        value={formData.descripcion1}
                        onChange={handleInputChange}
                        label="Título"

                        style={{ border: "2px solid #585857",  color:'#585857', background:'#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                        />
                </div>

                <div>
                    <FormControl
                    fullWidth
                    sx={{
                        border: "2px solid #585857",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        },
                    }}
                    >
                    <InputLabel id="color-select-label">Color</InputLabel>
                    <Select
                        labelId="color-select-label"
                        name="color"
                        type="color"
                        value={formData.color}
                        onChange={handleInputChange}
                        renderValue={(selected) => selected} 
                    >
                        {coloresDisponibles.map((color) => (
                        <MenuItem
                            key={color}
                            value={color}
                            sx={{
                            backgroundColor: formData.color === color ? "#e0e0e0" : "#fff",
                            color: "#585857",
                            "&:hover": {
                                backgroundColor: "#f0f0f0",
                            },
                            }}
                        >
                        
                            {color}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                            
                            {formData.color && (
                    <Box
                        sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        mt: 1,
                        }}
                    >
                        <Typography variant="body1" sx={{color:'#585857'}}>Este es el color seleccionado:</Typography>
                        <Box
                        sx={{
                            width: 200,
                            height: 24,
                            backgroundColor: formData.color,
                            border: '1px solid #000',
                            borderRadius: '4px',
                        }}
                        />
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        {formData.color}
                        </Typography>
                    </Box>
                    )}
                </div>

                


                <Button variant="contained" disabled={loading} sx={buttonStyle} type="submit">
                    {loading ? <CircularProgress size={24} /> : 'Guardar '}
                </Button>
            </form>
            
                   <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                                    <IoClose style={{color:'#585857'}}/>
                                </section>
                                <section style={{ textAlign: 'center' }}>
                                    <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                                    <p>{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        {/* Modal de error */}
                        <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                            <Box sx={modalStyle}>
                                <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: 'center' }}>
                                    <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                                    <p>{alertMessage}</p>
                                </section>
                            </Box>
                        </Modal>
            
                        {/* Modal de progreso */}
                        <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                            <Box sx={modalStyle}>
                            <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                    <IoClose />
                                </section>
                                <section style={{ textAlign: 'center', padding: '1rem' }}>
                                    <CircularProgress style={{ color: '#694B81' }} />
                                    <p>Procesando solicitud...</p>
                                </section>
                            </Box>
                        </Modal>
        </Box>
    );
};

const inputStyle = {
    border: "2px solid #585857",
    padding: "8px",
    borderRadius: "6px",
    width: "100%"
};


const buttonStyle = {
    backgroundColor: "#5E487B",
    color: "#fff",
    textTransform: "capitalize"
};


const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffff',
    border: '0px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '10px'
};
